import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import * as subscriptionPackActions from '../../../store/subscription-packs'
import Y from '../../../y18n'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'

import Button from '@material-ui/core/Button'

import Styles from '../../../common/styles'

import EventsList from '../components/events-list'

const mapStateToProps = state => ({
  subscriptionPacks: state.subscriptionPacks
})

const mapDispatchToProps = dispatch => ({
  subscriptionPackActions: bindActionCreators(subscriptionPackActions, dispatch)
})

class ViewSubscriptionPackLogsDialog extends Component {
  closeFormDialog = () => {
    this.props.subscriptionPackActions.clearActive()
    this.props.subscriptionPackActions.clearSubscriptionPackEvents()
    this.props.subscriptionPackActions.toggleDialog()
  }

  render () {
    const { subscriptionPacks, classes } = this.props

    if(!subscriptionPacks || (!subscriptionPacks.active && !subscriptionPacks.currentState.events)) return null

    return (
    
      <Dialog
      open={subscriptionPacks.currentState.events}
      onClose={() => this.closeFormDialog()}
      classes={{
        paper: classes.dialogContent
      }}
      >
        <DialogTitle>{Y`subpack_logs_page`}</DialogTitle>

        <DialogContent>
          {(subscriptionPacks && subscriptionPacks.event) ? (
            <EventsList events={subscriptionPacks.event.items}
                        eventsCount={subscriptionPacks.event.itemCount}
                        rowsPerPage={subscriptionPacks.event.rows}
                        page={subscriptionPacks.event.page}
                        onChangePage={this.handlePageChange}/>

          ) : ("No events")}
        </DialogContent>
        <DialogActions>
        <Button onClick={() => this.closeFormDialog()}>{Y`Close`}</Button>
        </DialogActions>
      </Dialog>

    )
  }

  handlePageChange = (event, page) => {
    this.props.subscriptionPackActions.setEventPage(page)
    this.props.subscriptionPackActions.getSubscriptionPackEvents()
  }

}

ViewSubscriptionPackLogsDialog = connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewSubscriptionPackLogsDialog)
export default withStyles(Styles)(ViewSubscriptionPackLogsDialog)


// WEBPACK FOOTER //
// ./src/pages/subscription-packs/containers/view-events.js